module.exports = __webpack_public_path__ + "img/verifyIdentity.53cc32dc.jpg";